import * as Yup from 'yup';
import { Param } from '../../../../../../shared/types/param';

export const initialValues: Param = {
    name: '',
    active: true,
    code: '',
    class: '',
    extra: '',
    valueSmart: '',
};

export const validationSchema = () =>
    Yup.object({
        name: Yup.string().required('El nombre es obligatorio'),
        valueSmart: Yup.string()
            .required('El código es obligatorio')
            .matches(/^\d+$/, 'El código solo puede contener números'),
        extra: Yup.string().required('La descripción es obligatoria'),
    });
